import Config from 'src/lib/config';
const isProduction = // Note that we explicitly set this for storybook because we want storybooks to work like prod by default.
  process.env.STORYBOOK === 'true' || Config.settings.isProdBackend;
export const notProduction = !isProduction;
